// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import styled from "styled-components";

const enum fields {
    thickness = "thickness",
}

export interface SeperatorProps extends WidgetProps {
    fields: {
        thickness: number;
    };
}

const Hr = styled.hr<{ thickness: number }>`
    border: 0;
    border-top: ${props => pxToRem(props.thickness ?? 3)} solid ${getColor("common.border")};
`;

const Seperator: FC<SeperatorProps> = ({ fields }) => {
    return <Hr thickness={fields.thickness} />;
};

const widgetModule: WidgetModule = {
    component: Seperator,
    definition: {
        group: "Basic",
        icon: "minus",
        fieldDefinitions: [
            {
                name: fields.thickness,
                displayName: "Thickness",
                editorTemplate: "IntegerField",
                defaultValue: 3,
                min: 1,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
